export default __webpack_public_path__ + "static/media/demo-2-raw.b1fdd6a8.jpg";